import { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { SiReact, SiNodedotjs, SiJavascript, SiExpress, SiMongodb, SiVite, SiCss3, SiHtml5, SiPostman, SiFlask, SiPython } from 'react-icons/si';

function WorkExamplesPage(){

    return(
        <div>
            <h3>Please be patient - demos running on Render may take up to 1 minute to load backend data</h3>

            

            <div className="project-box">
  <div className="project-description">
    <h2>Exercise Tracker App</h2>
    <h2>Technologies
    <SiReact size={24} title="React" />
  <SiNodedotjs size={24} title="Node.js" />
  <SiJavascript size={24} title="JavaScript" />
  <SiExpress size={24} title="Express" />
  <SiMongodb size={24} title="MongoDB" />
  <SiVite size={24} title="Vite" />
  </h2>
  
    <p>This web application provides users with a platform to log and manage their exercise routines, 
        including weight, repetitions, and date, with support for both kilograms and pounds. 
        Built using React for the frontend and Node.js with Express for the backend, the app leverages a 
        RESTful API to facilitate seamless communication between the client and server. Exercise data is securely stored in a MongoDB database, 
        enabling long-term storage and retrieval. Users can efficiently look up previous exercises, as well as edit or delete entries as needed. 
        The application is developed with modern web technologies, including JavaScript, CSS, and HTML, ensuring a responsive and user-friendly experience.</p>
    <h3><a href="https://mern-demo-front.onrender.com/"> Try it live! </a></h3>
    <h3><a href="https://github.com/stackpop2010/MERN-App-Demo"> Check out the source code </a></h3>
  </div>
  <div className="project-image">
    <img src="/exerciseapp.png" alt="Screenshot of exercise app project" />
  </div>
</div>

<div className="project-box">
  <div className="project-description">
    <h2>Animal Crossing Fishing Log</h2>
    <h2>Technologies
    <SiPython size={24} title="Python" />
  <SiReact size={24} title="React" />
  <SiNodedotjs size={24} title="Node.js" />
  <SiJavascript size={24} title="JavaScript" />
  <SiExpress size={24} title="Express" />
  <SiMongodb size={24} title="MongoDB" />
  <SiVite size={24} title="Vite" />
  </h2>
  
    <p>This web application provides users with a platform to log their fishing catches on the video game Animal Crossing New Horizons. 
       The application is developed with modern web technologies, including JavaScript, CSS, and HTML, ensuring a responsive and user-friendly experience.
       Additionally, a Python web scraper was used to obtain the images. </p>
    <h3><a href="https://fishing-react.onrender.com/"> Try it live! </a></h3>
    <h3><a href="https://github.com/stackpop2010/Fishing-MERN"> Check out the source code </a></h3>
  </div>
  <div className="project-image">
    <img src="/fishing.png" alt="Screenshot of fishing app project" />
  </div>
</div>

<div className="project-box">
  <div className="project-description">
    <h2>Tarot 3 Card Draw</h2>
    <h2>Technologies
    <SiPython size={24} title="Python" />
  <SiReact size={24} title="React" />
  <SiNodedotjs size={24} title="Node.js" />
  <SiJavascript size={24} title="JavaScript" />
    </h2>
  
    <p>This web application is a simple, randomized 3 card draw from a Tarot deck. A Python web scraper was used to obtain the images </p>
    <h3><a href="https://threecardtarot.onrender.com/"> Try it live! </a></h3>
    <h3><a href="https://github.com/stackpop2010/3cardtarot/tree/master"> Check out the source code </a></h3>
  </div>
  <div className="project-image">
    <img src="/tarot.png" alt="Screenshot of tarot app project" />
  </div>
</div>


        </div>
    )
}

export default WorkExamplesPage; 